import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const steps = [
  {
    n: '01',
    title: 'Open the map',
    desc: 'See people around you in real time. Each avatar represents a real person nearby.',
    svg: <svg width="28" height="28" viewBox="0 0 28 28" fill="none"><path d="M2 6L7 3L14 6L21 3L26 6V22L21 25L14 22L7 25L2 22V6Z" stroke="rgba(255,255,255,0.5)" strokeWidth="1.4" strokeLinejoin="round"/><line x1="7" y1="3" x2="7" y2="25" stroke="rgba(255,255,255,0.5)" strokeWidth="1.4"/><line x1="14" y1="6" x2="14" y2="22" stroke="rgba(255,255,255,0.5)" strokeWidth="1.4"/></svg>
  },
  {
    n: '02',
    title: 'Tap a profile',
    desc: 'See their age, intention, and distance. If they match what you\'re looking for, send a message.',
    svg: <svg width="28" height="28" viewBox="0 0 28 28" fill="none"><circle cx="14" cy="10" r="5.5" stroke="rgba(255,255,255,0.5)" strokeWidth="1.4"/><path d="M4 26C4 20.5 8.5 16 14 16C19.5 16 24 20.5 24 26" stroke="rgba(255,255,255,0.5)" strokeWidth="1.4" strokeLinecap="round"/></svg>
  },
  {
    n: '03',
    title: 'Message directly',
    desc: 'No match needed. No algorithm. Just send a message and start a real conversation.',
    svg: <svg width="28" height="28" viewBox="0 0 28 28" fill="none"><path d="M2 2H26V20H15L10 25V20H2V2Z" stroke="rgba(255,255,255,0.5)" strokeWidth="1.4" strokeLinejoin="round"/></svg>
  },
];

export default function Home() {
  const navigate = useNavigate();
  const [loaded, setLoaded] = useState(false);
  useEffect(() => { setTimeout(() => setLoaded(true), 100); }, []);

  return (
    <div style={{ minHeight:'100vh', background:'#080808', display:'flex', flexDirection:'column' }}>
      <style>{`
        @keyframes dash { to { stroke-dashoffset: -20; } }
        @keyframes dashreverse { to { stroke-dashoffset: 20; } }
        @keyframes pulse { 0%,100%{opacity:1} 50%{opacity:0.4} }
        @keyframes fadeInUp { from{opacity:0;transform:translateY(16px)} to{opacity:1;transform:translateY(0)} }
        .ad { animation: dash 1.5s linear infinite; }
        .adr { animation: dashreverse 1.5s linear infinite; }
      `}</style>

      <nav style={{ display:'flex', justifyContent:'space-between', alignItems:'center', padding:'24px 40px', borderBottom:'1px solid rgba(255,255,255,0.06)' }}>
        <div style={{ fontSize:'1.3rem', fontWeight:700, letterSpacing:'-0.5px', color:'white' }}>
          near<span style={{ color:'rgba(255,255,255,0.3)' }}>me</span>
        </div>
        <div style={{ display:'flex', gap:'10px' }}>
          <button onClick={() => navigate('/pricing')} style={{ padding:'10px 20px', background:'transparent', border:'1px solid rgba(255,255,255,0.08)', borderRadius:'100px', color:'rgba(255,255,255,0.4)', fontSize:'0.85rem', cursor:'pointer' }}>Pricing</button>
          <button onClick={() => navigate('/login')} style={{ padding:'10px 24px', background:'white', color:'#080808', border:'none', borderRadius:'100px', fontSize:'0.85rem', fontWeight:600, cursor:'pointer' }}>Sign in</button>
        </div>
      </nav>

      <div style={{ flex:1, display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', padding:'60px 24px', opacity:loaded?1:0, transform:loaded?'translateY(0)':'translateY(12px)', transition:'all 0.7s ease' }}>

        <div style={{ display:'inline-flex', alignItems:'center', gap:'7px', border:'1px solid rgba(255,255,255,0.07)', borderRadius:'100px', padding:'5px 14px', marginBottom:'28px', fontSize:'0.75rem', color:'rgba(255,255,255,0.3)' }}>
          <div style={{ width:5, height:5, borderRadius:'50%', background:'#00d68f', animation:'pulse 2s infinite' }}/>
          Live now in your city
        </div>

        <h1 style={{ fontSize:'clamp(3rem,9vw,6.5rem)', fontWeight:700, lineHeight:1, letterSpacing:'-4px', marginBottom:'18px', textAlign:'center', color:'white' }}>
          Stop swiping.<br/>
          <span style={{ color:'rgba(255,255,255,0.25)' }}>Start living.</span>
        </h1>

        <p style={{ fontSize:'1rem', color:'rgba(255,255,255,0.35)', maxWidth:'400px', lineHeight:1.7, marginBottom:'36px', textAlign:'center', fontWeight:300 }}>
          See who is around you in real time.<br/>No algorithm. No feed. Just people nearby.
        </p>

        <div style={{ display:'flex', gap:'10px', flexWrap:'wrap', justifyContent:'center', marginBottom:'60px' }}>
          <button onClick={() => navigate('/signup')} style={{ padding:'15px 48px', background:'white', color:'#080808', border:'none', borderRadius:'100px', fontSize:'0.95rem', fontWeight:600, cursor:'pointer' }}>
            Get started — free
          </button>
          <button onClick={() => navigate('/pricing')} style={{ padding:'15px 28px', background:'transparent', color:'rgba(255,255,255,0.4)', border:'1px solid rgba(255,255,255,0.08)', borderRadius:'100px', fontSize:'0.95rem', cursor:'pointer' }}>
            See pricing
          </button>
        </div>

        {/* SVG Map illustration */}
        <svg width="100%" viewBox="0 0 680 420" style={{ maxWidth:'680px', borderRadius:'20px', display:'block', transform:loaded?'scale(1)':'scale(0.92)', opacity:loaded?1:0, transition:'transform 0.9s cubic-bezier(0.16,1,0.3,1), opacity 0.7s ease', marginBottom:'60px' }}>
          <rect width="680" height="420" fill="#080808"/>
          <line x1="0" y1="105" x2="680" y2="105" stroke="#111" strokeWidth="1"/>
          <line x1="0" y1="210" x2="680" y2="210" stroke="#111" strokeWidth="1"/>
          <line x1="0" y1="315" x2="680" y2="315" stroke="#111" strokeWidth="1"/>
          <line x1="170" y1="0" x2="170" y2="420" stroke="#111" strokeWidth="1"/>
          <line x1="340" y1="0" x2="340" y2="420" stroke="#111" strokeWidth="1"/>
          <line x1="510" y1="0" x2="510" y2="420" stroke="#111" strokeWidth="1"/>
          <path d="M0 210 Q200 195 340 215 Q480 235 680 220" fill="none" stroke="#161616" strokeWidth="22"/>
          <path d="M0 210 Q200 195 340 215 Q480 235 680 220" fill="none" stroke="#0f0f0f" strokeWidth="14"/>
          <path d="M310 0 Q320 150 315 420" fill="none" stroke="#161616" strokeWidth="18"/>
          <path d="M310 0 Q320 150 315 420" fill="none" stroke="#0f0f0f" strokeWidth="10"/>
          <path d="M460 0 Q455 120 458 420" fill="none" stroke="#161616" strokeWidth="14"/>
          <path d="M0 310 Q340 295 680 320" fill="none" stroke="#161616" strokeWidth="12"/>
          <path className="ad" d="M255 205 Q340 148 432 188" fill="none" stroke="#87CEEB" strokeWidth="1.2" strokeDasharray="5 5" opacity="0.4"/>
          <path className="adr" d="M255 205 Q215 260 175 282" fill="none" stroke="#FFB6C1" strokeWidth="1" strokeDasharray="4 4" opacity="0.3"/>
          <path className="ad" d="M432 188 Q470 230 510 264" fill="none" stroke="#87CEEB" strokeWidth="1" strokeDasharray="4 4" opacity="0.2"/>
          <circle cx="255" cy="210" r="60" fill="none" stroke="#87CEEB" strokeWidth="0.5" opacity="0.08"/>
          <circle cx="255" cy="210" r="40" fill="none" stroke="#87CEEB" strokeWidth="0.5" opacity="0.12"/>
          <circle cx="255" cy="210" r="24" fill="#141420" stroke="#87CEEB" strokeWidth="2"/>
          <circle cx="255" cy="201" r="7.5" fill="#87CEEB" opacity="0.9"/>
          <path d="M245 217 Q255 227 265 217 L261 212 Q255 215 249 212Z" fill="#87CEEB" opacity="0.9"/>
          <circle cx="274" cy="192" r="7" fill="#080808" stroke="#87CEEB" strokeWidth="1.5"/>
          <circle cx="274" cy="192" r="3.5" fill="#00d68f"/>
          <circle cx="432" cy="192" r="22" fill="#1a1010" stroke="#FFB6C1" strokeWidth="2"/>
          <circle cx="432" cy="183" r="6.5" fill="#FFB6C1" opacity="0.9"/>
          <rect x="426" y="191" width="12" height="10" rx="2" fill="#FFB6C1" opacity="0.9"/>
          <circle cx="448" cy="176" r="6.5" fill="#080808" stroke="#FFB6C1" strokeWidth="1.5"/>
          <circle cx="448" cy="176" r="3" fill="#00d68f"/>
          <circle cx="175" cy="285" r="19" fill="#12101a" stroke="#BF5AF2" strokeWidth="1.8"/>
          <circle cx="175" cy="277" r="6" fill="#BF5AF2" opacity="0.85"/>
          <rect x="169" y="284" width="12" height="9" rx="2" fill="#BF5AF2" opacity="0.85"/>
          <circle cx="510" cy="268" r="19" fill="#141414" stroke="#FFD700" strokeWidth="1.8"/>
          <circle cx="510" cy="260" r="6" fill="#FFD700" opacity="0.8"/>
          <path d="M503 269 Q510 277 517 269 L514 265 Q510 267 506 265Z" fill="#FFD700" opacity="0.8"/>
          <rect x="270" y="350" width="140" height="22" rx="11" fill="#111" stroke="rgba(255,255,255,0.07)" strokeWidth="1"/>
          <circle cx="285" cy="361" r="4" fill="#00d68f"/>
          <text x="350" y="365" textAnchor="middle" fontSize="11" fill="rgba(255,255,255,0.3)" fontFamily="system-ui">4 people nearby</text>
          <text x="340" y="403" textAnchor="middle" fontSize="16" fontWeight="700" fill="rgba(255,255,255,0.7)" fontFamily="system-ui" letterSpacing="-1">nearme</text>
        </svg>

        {/* How it works */}
        <div style={{ width:'100%', maxWidth:'680px', marginBottom:'48px' }}>
          <div style={{ textAlign:'center', marginBottom:'32px' }}>
            <div style={{ fontSize:'0.72rem', color:'rgba(255,255,255,0.2)', textTransform:'uppercase', letterSpacing:'2px', marginBottom:'8px' }}>How it works</div>
            <h2 style={{ fontSize:'clamp(1.4rem,3vw,2rem)', fontWeight:700, color:'white', letterSpacing:'-1px', margin:0 }}>Three steps. That's it.</h2>
          </div>
          <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit, minmax(180px, 1fr))', gap:'16px' }}>
            {steps.map((s, i) => (
              <div key={i} style={{ background:'rgba(255,255,255,0.02)', border:'1px solid rgba(255,255,255,0.06)', borderRadius:'18px', padding:'22px', animation:`fadeInUp 0.6s ease ${i*0.15}s both` }}>
                <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:'14px' }}>
                  {s.svg}
                  <span style={{ fontSize:'0.72rem', color:'rgba(255,255,255,0.12)', fontWeight:700, letterSpacing:'1px' }}>{s.n}</span>
                </div>
                <div style={{ fontWeight:600, color:'white', fontSize:'0.92rem', marginBottom:'7px' }}>{s.title}</div>
                <div style={{ color:'rgba(255,255,255,0.3)', fontSize:'0.8rem', lineHeight:1.6 }}>{s.desc}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Stats */}
        <div style={{ display:'flex', gap:'40px', marginTop:'8px', paddingTop:'28px', borderTop:'1px solid rgba(255,255,255,0.05)', flexWrap:'wrap', justifyContent:'center' }}>
          {[['Free','Forever'],['Real-time','Map'],['Direct','Messaging']].map(([v,l]) => (
            <div key={l} style={{ textAlign:'center' }}>
              <div style={{ fontSize:'1rem', fontWeight:600, color:'white' }}>{v}</div>
              <div style={{ fontSize:'0.72rem', color:'rgba(255,255,255,0.2)', marginTop:'3px', textTransform:'uppercase', letterSpacing:'0.8px' }}>{l}</div>
            </div>
          ))}
        </div>

        <div style={{ display:'flex', gap:'18px', marginTop:'24px' }}>
          {[['Terms','/terms'],['Privacy','/privacy'],['Pricing','/pricing']].map(([label,path]) => (
            <span key={label} onClick={() => navigate(path)} style={{ fontSize:'0.75rem', color:'rgba(255,255,255,0.15)', cursor:'pointer' }}>{label}</span>
          ))}
        </div>
      </div>
    </div>
  );
}
